import "./SelectionButton.css";
// import {AudioDescriptions} from "@hmpu/powerups.services.audio-descriptions";
import AudioDescriptions from "../Accessibility/AudioDescriptions";
import { useStore } from "@hmpu/powerups.store";

export declare type SelectionButtonClickHandlerProps = {
  positionIndex: number;
  slug: string;
  label: string;
  target: HTMLButtonElement;
  setTargetValue: (v: string) => void;
  setIsButtonDisabled: (v: any) => void;
  goToNextPage: () => void;
  setGameLevel: (level: number) => void;
};

export type SelectionButtonProps = {
  positionIndex: number;
  slug: string;
  label: string;
  ariaLabel: string;
  selectionImage: string;
  selectionCard?: string;
  lineDrip: string;
  setTargetValue: (v: string) => void;
  setIsButtonDisabled: (v: any) => void;
  goToNextPage: () => void;
};

export const btnClickHandler = ({
  positionIndex,
  slug,
  label,
  target,
  setTargetValue,
  setIsButtonDisabled,
  goToNextPage,
  setGameLevel,
}: SelectionButtonClickHandlerProps) => {
  // TODO: background glow on select
  document
    .querySelector(".selection-btn.selected")
    ?.classList.remove("selected");
  target.classList.add("selected");
  setTargetValue(slug);
  setIsButtonDisabled(false);
  goToNextPage();
  setGameLevel(positionIndex);
};

export function SelectionButton(props: SelectionButtonProps) {
  const {
    slug,
    label,
    ariaLabel,
    selectionImage,
    selectionCard,
    lineDrip,
    setTargetValue,
    setIsButtonDisabled,
    goToNextPage,
  } = props; // add goToNextPage here
  const descriptionsEnabled = useStore((state) => state.descriptionsEnabled);
  const buttonDescription = () => {
    if (descriptionsEnabled) {
      AudioDescriptions.speak([ariaLabel]);
    }
  };
  const setGameLevel = useStore((state) => state.setGameLevel);

  return (
    <button
      className={`selection-btn ${slug}-selection-btn`}
      aria-label={ariaLabel}
      onClick={(e: any) => {
        e.stopPropagation();
        btnClickHandler({
          positionIndex: props.positionIndex,
          slug: slug,
          label: ariaLabel,
          target: e.currentTarget,
          setTargetValue: setTargetValue,
          setIsButtonDisabled: setIsButtonDisabled,
          goToNextPage: goToNextPage,
          setGameLevel,
        });
        buttonDescription();
      }}
      value={slug}
      data-slug={slug}
    >
      {/* <div className="selection-btn-label">
        <span className="label-stroke" aria-hidden="true">{ariaLabel}</span>
        <span className="label">{ariaLabel}</span>
      </div> */}
      <div className="selection-btn-background"></div>
      <div
        className="selection-btn-sprite-image-container"
        style={{
          backgroundImage: `url(${selectionCard})`,
          backgroundSize: "contain",
        }}
      >
        <div className="image">
          <img
            src={`${selectionImage}`}
            className="selection-btn-sprite-image"
            alt={ariaLabel}
            data-slug={slug}
          />
          {/* {selectionCard ? (
            <img
              src={`${lineDrip}`}
              className="selection-btn-linedrip"
              alt=""
            />
          ) : null} */}
        </div>
      </div>
    </button>
  );
}
